import { useState, useRef, useEffect } from "react";

import Modal from "../../components/Modal.js";

import DATAG from "../data/_gallery.json";

import "./gallery.css";

const Gallery = () => {
   const [modalState, setModalState] = useState(false);
   const GALLERY = useRef(Object.keys(DATAG.galleryMain));
   const posX = useRef([0, 0]);
   const setX = (e) => {
      posX.current = [e.clientX, e.clientY] || [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
   }
   const swipe = (d, e) => {
      e.stopPropagation();
      setModalState(GALLERY.current[d])
   }
   const handleSwipe = (e, key) => {
      let X = [e.clientX, e.clientY] || [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
      // if swipe is more than scroll then x-difference else false
      let swiped = (Math.abs(posX.current[1] - X[1]) < (Math.abs(posX.current[0] - X[0]) + 20)) && posX.current[0] - X[0];
      if (Math.abs(swiped) > 20) { // if its big enough
         let incremental = (swiped > 0) ? 1 : -1;
         let indx = GALLERY.current.indexOf(key);
         let next = (indx === GALLERY.current.length - 1) ? 0 : indx + incremental;
         swipe(next, e);
      }
   };

   useEffect(() => {
      GALLERY.current.sort(function (a, b) { return Math.random() - 0.5; });
      return () => {
      }
   }, [])


   let lArrow = <svg height="50" width="42" alt="larrow">
      {/* <text x="10" y="10" fill="#FFFFFF50">
         {"►►"}
      </text> */}
      <g fill="white" stroke="#00000020">
         <path d="M30 0 l0 50 l-20 -25 l20 -25" />
         {/* <path d="M40 0 l0 20 l-10 -10 l10 -10" /> */}
         {/* <path d="M25 0 l0 20 l-10 -10 l10 -10" /> */}
      </g>
   </svg>
   let rArrow = <svg height="50" width="42" alt="rarrow">
      <g fill="white" stroke="#00000020">
         <path d="M10 0 l0 50 l20 -25 l-20 -25" />
         {/* <path d="M15 0 l0 20 l10 -10 l-10 -10" /> */}
      </g>
   </svg>

   return (

      <div className="sections">
         <h2>&nbsp;Gallery</h2>
         <div className="gallery">
            {GALLERY.current.map((key) => {
               return (
                  <div className="gallery-cards" key={key}
                     onClick={() => {
                        setModalState(key);
                     }} aria-hidden
                  >
                     <span>{key}</span>
                     <img src={`gallery1/${DATAG.galleryMain[key][0]}`} alt={key}></img>
                     <p>{DATAG.galleryMain[key][1]}</p>
                  </div>
               );
            })
            }

            <Modal modalState={modalState} style={{ width: "100%" }}>
               <div id="modalchild" onClick={() => setModalState(false)} onBlur={() => setModalState(false)} aria-hidden title="Click or tap anywhere to close">
                  {modalState ?
                     <>
                        <div className="gallery-zoom">

                           <img src={`gallery1/${DATAG.galleryMain[modalState][0]}`} alt="" aria-hidden width={"100%"}
                              onTouchStart={setX}
                              onDragStart={setX}
                              onDragEnd={(e) => handleSwipe(e, [modalState][0])}
                              onTouchEnd={(e) => handleSwipe(e, [modalState][0])}
                           >
                           </img>

                           {GALLERY.current.indexOf([modalState][0]) === 0 ? null : <div className="gallery-arrows left" onClick={(e) => swipe(GALLERY.current.indexOf([modalState][0]) - 1, e)} aria-hidden>{lArrow}</div>
                           }

                           {GALLERY.current.indexOf([modalState][0]) === GALLERY.current.length - 1 ? null :
                              <div className="gallery-arrows right" onClick={(e) => swipe(GALLERY.current.indexOf([modalState][0]) + 1, e)} aria-hidden>{rArrow}</div>
                           }

                        </div>

                        <i>{modalState}</i> -&nbsp;
                        {DATAG.galleryMain[modalState][1]}
                        <hr />
                        <small><i>Click or tap anywhere to close</i></small>
                     </>
                     : null}
               </div>
            </Modal >

         </div>

      </div >
   )
}

export default Gallery;